import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { liabilityApi } from '@store/rtk/liability';
import { beautifyDateTime } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type LiabilityType = {
  liabilityTableData: TableData;
};

const { liabilityTableColumns } = TABLE_COLUMNS;

const initialState: LiabilityType = {
  liabilityTableData: {
    columns: liabilityTableColumns,
    rows: [],
    size: 5,
  },
};

export const liabilitySlice = createSlice({
  name: 'liability',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      liabilityApi.endpoints.getLiabilityTableData.matchFulfilled,
      (state, { payload }) => {
        state.liabilityTableData = {
          ...state.liabilityTableData,
          rows: [
            ...payload.content.map((el, idx) => ({
              ...el,
              id: el.id ? el.id : idx,
              effectiveDate: beautifyDateTime(el?.effectiveDate),
              expirationDate: beautifyDateTime(el?.expirationDate),
            })),
          ],
          ...payload,
          requestTablePageChange: liabilityApi.endpoints.getLiabilityTableData,
        };
      }
    );
  },
});

export const selectLiability = (state: { liability: LiabilityType }) =>
  state.liability;
export const liabilityReducer = liabilitySlice.reducer;
